/** @param {string | undefined} mode */
export function regenerateInstruction(mode) {
  if (mode === 'try_again') {
    return 'Regenerate a new, different answer to the same question.'
  }
  if (mode === 'think_longer') {
    return (
      'Regenerate the answer with more depth. Be more thorough, include steps, edge cases, and any important details.'
    )
  }
  if (mode === 'search_web') {
    return (
      'Use web search results if available. If you cannot browse, still provide the best possible answer and state assumptions.'
    )
  }
  return ''
}
